var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.clickEvent}},[_c('div',{attrs:{"id":"nav"}},[(_vm.fullPage())?_c('navbar',{attrs:{"element":_vm.clicked}}):_vm._e()],1),_c('router-view'),_c('router-view',{attrs:{"name":"landing"}}),_c('div',{attrs:{"id":"footer"}},[_c('foot')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }